import React from "react";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";
import repImage from "../../assets/rep.jpg";

function HomePage() {
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const handleLogIn = () => {
    navigate("/login");
  };

  const handleContactUs = () => {
    // For now, scroll to bottom or open email
    window.location.href = "mailto:help@reppi.co";
  };

  return (
    <main className="home-page">
      {/* Hero Section */}
      <section className="home-hero-section">
        <div className="home-hero-container">
          <div className="home-hero-content">
            <h1 className="home-hero-title">
              Build consistent, high-performing sales teams.
            </h1>
          </div>
          <div className="home-hero-image">
            <img
              src={repImage}
              alt="Sales representative"
              className="home-hero-img"
            />
          </div>
          <div className="home-hero-description">
            <p>
              Track recruits, run training, and keep reps engaged in one simple
              product. Reppi saves time, reduces turnover, and helps teams grow
              faster.
            </p>
          </div>
        </div>
      </section>

      {/* What Makes Reppi Different Section */}
      <section className="home-features-section">
        <div className="home-features-container">
          <h2 className="home-features-title">What makes Reppi different?</h2>
          <div className="home-features-grid">
            <div className="home-feature-card">
              <div className="home-feature-icon">
                <span className="material-symbols-outlined">play_circle</span>
              </div>
              <h3>Training video analytics</h3>
              <p>
                See which reps are watching training videos so you know who's
                prepared, who's falling behind, and who needs extra support.
              </p>
            </div>

            <div className="home-feature-card">
              <div className="home-feature-icon">
                <span className="material-symbols-outlined">person_search</span>
              </div>
              <h3>Recruit tracking and reminders</h3>
              <p>
                Recruiting's easy to miss. Reppi helps you track where every
                recruit is in the process, reminds you who to follow up with,
                and keeps all your messages organized.
              </p>
            </div>

            <div className="home-feature-card">
              <div className="home-feature-icon">
                <span className="material-symbols-outlined">description</span>
              </div>
              <h3>Centralized offer documents</h3>
              <p>
                Stop emailing PDFs and chasing documents. Reppi keeps every file
                in one easy-to-find spot, so managers always know where things
                are.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* View Our Features Section */}
      <section className="home-cta-section">
        <div className="home-cta-container">
          {/* <h3>View our features</h3> */}
          <div className="home-cta-buttons">
            {/* <button
              className="btn btn-md btn-link"
              onClick={() => handleFeatureClick("/features/training")}
            >
              Training
            </button>
            <button
              className="btn btn-md btn-link"
              onClick={() => handleFeatureClick("/features/recruiting")}
            >
              Recruiting
            </button>
            <button
              className="btn btn-md btn-link"
              onClick={() => handleFeatureClick("/features/performance")}
            >
              Performance
            </button>
            <button
              className="btn btn-md btn-link"
              onClick={() => handleFeatureClick("/features/communication")}
            >
              Communication
            </button> */}
            <button
              className="btn btn-md btn-primary"
              onClick={handleContactUs}
            >
              Get Demo
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}

export default HomePage;
